import type { Discipline, PlayerInfo } from '@/data/types';

export interface ParsedEntry {
  players: PlayerInfo[];
}

export interface ParseError {
  line: number; // 1-based
  message: string;
}

export interface ParseResult {
  entries: ParsedEntry[];
  errors: ParseError[];
}

function parsePlayer(text: string): PlayerInfo {
  // "Имя, Клуб" → { name, club }
  const [namePart, clubPart] = text.split(',').map((s) => s.trim());
  if (clubPart) {
    return { name: namePart, club: clubPart };
  }
  return { name: namePart };
}

export function parseParticipantsList(input: string, discipline: Discipline): ParseResult {
  const lines = input.split('\n');
  const entries: ParsedEntry[] = [];
  const errors: ParseError[] = [];

  lines.forEach((rawLine, idx) => {
    const lineNo = idx + 1;
    const line = rawLine.trim();
    if (!line) return;

    if (discipline === 'SINGLES') {
      const player = parsePlayer(line);
      if (!player.name) {
        errors.push({ line: lineNo, message: 'Пустое имя' });
        return;
      }
      entries.push({ players: [player] });
      return;
    }

    // DOUBLES: ожидаем "Имя1 / Имя2" (опционально с клубами через запятую)
    if (!line.includes('/')) {
      errors.push({
        line: lineNo,
        message: 'Для парного разряда нужно два имени через "/"',
      });
      return;
    }

    const rawParts = line.split('/').map((s) => s.trim());
    if (rawParts.length !== 2) {
      errors.push({
        line: lineNo,
        message: 'Пара — ровно два имени через "/"',
      });
      return;
    }

    const [aRaw, bRaw] = rawParts;
    const a = parsePlayer(aRaw);
    const b = parsePlayer(bRaw);

    if (!a.name) {
      errors.push({ line: lineNo, message: 'Пустое имя первого игрока' });
      return;
    }
    if (!b.name) {
      errors.push({ line: lineNo, message: 'Пустое имя второго игрока' });
      return;
    }

    entries.push({ players: [a, b] });
  });

  return { entries, errors };
}
